import styled from "styled-components";

export const Sections = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
  max-height: 40vh;
  padding: 10px 0;
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #494949;
`;

export const ItemsList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0 0 0 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Item = styled.li`
  font-size: 14px;
  line-height: 1.3;
  color: #6b6b6b;
`;

export const PriceDetail = styled.span`
  display: block;
  font-size: 14px;
  color: #999999;
`;
